module.exports = __webpack_public_path__ + "img/fieldwork-2006-mudanjiang.cf38af5f.jpg";